import { useQuery } from 'react-query';
import {
  getTradingPhotoCard,
  type GetTradingPhotoCardResponse
} from '../../services/tradingPhotoCardService';

export function useGetTradingPhotoCard(id: string) {
  return useQuery<GetTradingPhotoCardResponse, Error, GetTradingPhotoCardResponse>(
    ['tradingPhotoCard', id],
    () => getTradingPhotoCard(id),
    {
      enabled: !!id,
      staleTime: 30 * 1000,
      cacheTime: 5 * 60 * 1000
    }
  );
}
